import React, {
  useState,
  useRef,
  useEffect,
  useCallback,
  useContext,
} from "react";

 
import { useSpring, animated } from "react-spring";
import { MdClose } from "react-icons/md";
import { RewardManagementContext } from "../context/RewardManagementContext";
import { toast } from "react-toastify";

const ModelClaim = ({ showModalClaim, setShowModalClaim, formValues, setFormValues}) => {

  const initialValue = { blockTime: "", rewardAmount: "0.00", totalFee:"0.00", totalRewards:"0.00" };
  //const [formValues, setFormValues] = useState(initialValue);
  const { cashoutReward } = useContext(RewardManagementContext);
  
  const Rewardcashout = (createTime) => {
    
    cashoutReward(createTime);
  }

  return (
    <>
      {showModalClaim ? (
        <div className="createNode ">
          <form>
            <div className="model-head">
              <a
                className="closeBtn"
                onClick={() => setShowModalClaim((prev) => !prev)}
              >
                <MdClose />
              </a>
              <p className="text-justify">
                Reward will be transfer after dedution of the fee, are you sure you like to proceed?
              </p>
            </div>

            <div className="model-footer">
              <div className="mt-2 text-white text-xs mt-2">
                <p>
                  *rate is calculated with the actual $METEST price and it may
                  vary depending on variouse factor{" "}
                </p>
              </div>
              <div className="text-white text-xs mt-2">
                {/* <p>Your $MSTATE token will be distributed as follows:</p> */}
                <ul>
                  <li>Total Fee: {formValues.totalFee}</li>
                  <li>Rewards: {formValues.rewardAmount}</li>
                  <li>Total Reward after deduction: {formValues.totalRewards}</li>                   
                </ul>

                 
                <div className="mt-2 mb-2 p-0 flex flex-row justify-end items-center rounded-md place-items-end">
                  <a className="btn " onClick={() => Rewardcashout(formValues.blockTime)} >
                    <span>Proceed</span>
                  </a>

                  <a className="btn " onClick={() => setShowModalClaim((prev) => !prev)} >
                    <span>Cancel</span>
                  </a>
                </div>
              </div>
            </div>
          </form>
        </div>
      ) : null}
    </>
  );
};
export default ModelClaim;
